// extracted by css-extract-rspack-plugin
export default {"cls1":"TopSection-cls1_LxB","cls2":"TopSection-cls2_F4Z TopSection-cls1_LxB"};